import { render, staticRenderFns } from "./shang.vue?vue&type=template&id=69ed0ffa&scoped=true&"
import script from "./shang.vue?vue&type=script&lang=js&"
export * from "./shang.vue?vue&type=script&lang=js&"
import style0 from "./shang.vue?vue&type=style&index=0&id=69ed0ffa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ed0ffa",
  null
  
)

export default component.exports